module.exports = __webpack_public_path__ + "static/media/couches-3.ad16c2d6.jpg";